var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelptip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99974 1.36641C3.88854 1.36641 1.36641 3.88854 1.36641 6.99974C1.36641 10.111 3.88854 12.6331 6.99974 12.6331C10.111 12.6331 12.6331 10.111 12.6331 6.99974C12.6331 3.88854 10.111 1.36641 6.99974 1.36641ZM0.0664062 6.99974C0.0664062 3.17056 3.17056 0.0664062 6.99974 0.0664062C10.8289 0.0664062 13.9331 3.17056 13.9331 6.99974C13.9331 10.8289 10.8289 13.9331 6.99974 13.9331C3.17056 13.9331 0.0664062 10.8289 0.0664062 6.99974ZM5.69974 6.78307C5.69974 6.42409 5.99076 6.13307 6.34974 6.13307H7.21641C7.57539 6.13307 7.86641 6.42409 7.86641 6.78307V9.16641H8.08307C8.44205 9.16641 8.73307 9.45743 8.73307 9.81641C8.73307 10.1754 8.44205 10.4664 8.08307 10.4664H6.34974C5.99076 10.4664 5.69974 10.1754 5.69974 9.81641C5.69974 9.45743 5.99076 9.16641 6.34974 9.16641H6.56641V7.43307H6.34974C5.99076 7.43307 5.69974 7.14206 5.69974 6.78307ZM6.99974 5.26641C7.47839 5.26641 7.86641 4.87838 7.86641 4.39974C7.86641 3.9211 7.47839 3.53307 6.99974 3.53307C6.5211 3.53307 6.13307 3.9211 6.13307 4.39974C6.13307 4.87838 6.5211 5.26641 6.99974 5.26641Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelptip);
export default __webpack_public_path__ + "static/media/helptip.62c42550c940843b5d68458acc14b9a3.svg";
export { ForwardRef as ReactComponent };